// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.0
//   protoc               v3.21.12
// source: modifysection.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Section } from "./schema";

export const protobufPackage = "modifysection";

export interface ModifySectionRequest {
  /** The section to be modified, containing the current content and feedback. */
  currentState?:
    | Section
    | undefined;
  /** Previous sections for context (not currently used in prompt injection but available). */
  previousSections: Section[];
  /** The summary section markdown. Injected into the prompt as {Insert Summary markdown}. */
  summary?: string | undefined;
}

export interface ModifySectionResponse {
  /** The updated section content generated by the AI. */
  updatedSection: Section | undefined;
}

function createBaseModifySectionRequest(): ModifySectionRequest {
  return { currentState: undefined, previousSections: [], summary: undefined };
}

export const ModifySectionRequest: MessageFns<ModifySectionRequest> = {
  encode(message: ModifySectionRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.currentState !== undefined) {
      Section.encode(message.currentState, writer.uint32(10).fork()).join();
    }
    for (const v of message.previousSections) {
      Section.encode(v!, writer.uint32(18).fork()).join();
    }
    if (message.summary !== undefined) {
      writer.uint32(26).string(message.summary);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ModifySectionRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseModifySectionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.currentState = Section.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.previousSections.push(Section.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.summary = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ModifySectionRequest {
    return {
      currentState: isSet(object.currentState)
        ? Section.fromJSON(object.currentState)
        : isSet(object.current_state)
        ? Section.fromJSON(object.current_state)
        : undefined,
      previousSections: globalThis.Array.isArray(object?.previousSections)
        ? object.previousSections.map((e: any) => Section.fromJSON(e))
        : globalThis.Array.isArray(object?.previous_sections)
        ? object.previous_sections.map((e: any) => Section.fromJSON(e))
        : [],
      summary: isSet(object.summary) ? globalThis.String(object.summary) : undefined,
    };
  },

  toJSON(message: ModifySectionRequest): unknown {
    const obj: any = {};
    if (message.currentState !== undefined) {
      obj.currentState = Section.toJSON(message.currentState);
    }
    if (message.previousSections?.length) {
      obj.previousSections = message.previousSections.map((e) => Section.toJSON(e));
    }
    if (message.summary !== undefined) {
      obj.summary = message.summary;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ModifySectionRequest>, I>>(base?: I): ModifySectionRequest {
    return ModifySectionRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ModifySectionRequest>, I>>(object: I): ModifySectionRequest {
    const message = createBaseModifySectionRequest();
    message.currentState = (object.currentState !== undefined && object.currentState !== null)
      ? Section.fromPartial(object.currentState)
      : undefined;
    message.previousSections = object.previousSections?.map((e) => Section.fromPartial(e)) || [];
    message.summary = object.summary ?? undefined;
    return message;
  },
};

function createBaseModifySectionResponse(): ModifySectionResponse {
  return { updatedSection: undefined };
}

export const ModifySectionResponse: MessageFns<ModifySectionResponse> = {
  encode(message: ModifySectionResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.updatedSection !== undefined) {
      Section.encode(message.updatedSection, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ModifySectionResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseModifySectionResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.updatedSection = Section.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ModifySectionResponse {
    return {
      updatedSection: isSet(object.updatedSection)
        ? Section.fromJSON(object.updatedSection)
        : isSet(object.updated_section)
        ? Section.fromJSON(object.updated_section)
        : undefined,
    };
  },

  toJSON(message: ModifySectionResponse): unknown {
    const obj: any = {};
    if (message.updatedSection !== undefined) {
      obj.updatedSection = Section.toJSON(message.updatedSection);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ModifySectionResponse>, I>>(base?: I): ModifySectionResponse {
    return ModifySectionResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ModifySectionResponse>, I>>(object: I): ModifySectionResponse {
    const message = createBaseModifySectionResponse();
    message.updatedSection = (object.updatedSection !== undefined && object.updatedSection !== null)
      ? Section.fromPartial(object.updatedSection)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
